/**
 * Test if the `condition` is truthy. If `condition` is false, it throws
 * an error with an optional message. If the message parameter is missing,
 * it throws an error with a default message.
 */
export function assert(condition, msg) {
    if (!condition) {
        fail(msg);
    }
}
/**
 * Throws an Error with the (optionally) provided error message.
 */
export function fail(msg) {
    throw new Error("INTERNAL ASSERTION FAILED: ".concat(msg));
}
